
import { supabase } from "@/integrations/supabase/client";

/**
 * Tests the connection to the OpenAI API
 * @returns Object with success status and message
 */
export const testOpenAIConnection = async (): Promise<{success: boolean, message: string}> => {
  try {
    console.log("Testing OpenAI API connection...");
    
    const testResponse = await supabase.functions.invoke('analyse-resume', {
      body: { test: true }
    });
    
    if (testResponse.error) {
      console.error("API test error:", testResponse.error);
      return {
        success: false,
        message: `Failed to test API: ${testResponse.error.message || 'Unknown error'}`
      };
    }
    
    console.log("API test successful:", testResponse.data);
    return testResponse.data;
  } catch (error) {
    console.error("Error testing OpenAI connection:", error);
    return {
      success: false,
      message: `Error: ${error instanceof Error ? error.message : 'Unknown error'}`
    };
  }
};
